import type { BoxId, GraphPath } from '@ipfabric/utils';

// NIM-5159 we need to determine box ID from graph path
export const getBoxIdByPath = (graphPath: GraphPath): BoxId => graphPath;
